import { render, staticRenderFns } from "./productParticulars.vue?vue&type=template&id=5984bd6e&scoped=true&"
import script from "./productParticulars.vue?vue&type=script&lang=js&"
export * from "./productParticulars.vue?vue&type=script&lang=js&"
import style0 from "./productParticulars.vue?vue&type=style&index=0&id=5984bd6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5984bd6e",
  null
  
)

export default component.exports